const TrainerCore = require("../TrainerCore");

const settings = {
	showStarProgress: true,
	canReplayProblem: true,
	canSwitchSet: true,
	//These 2 are different than standard:
	canEarnStarsOnTrialSubmission: true,
	showMessageOnStarEarned: true,
};

const getLastAvailableIndex = function(result) {
	const numCompleted = result.problems.filter(p => p.outcome).length;
	// return Math.min(Math.max(numCompleted + 2, 0), result.problems.length - 1);
	const numCorrect = result.problems.filter(p => p.outcome === "correct")
		.length;
	return Math.min(numCompleted + numCorrect, result.problems.length - 1);
};

const shouldIntervene = function(result) {
	return TrainerCore.genericShouldIntervene(result.problems);
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

module.exports = {
	settings,
	getLastAvailableIndex,
	getSetProgressInfo,
	shouldIntervene,
};
